module.exports = __webpack_public_path__ + "static/media/PrincessUnlimitedBookCover.28935070.jpg";